"use client";

import {
  NavigationMenu,
  NavigationMenuList,
} from "@workspace/ui/components/navigation-menu";
import { NavMenuProps } from "../types";
import { NavigationNavItem } from "./nav-item-renderers";

export function DesktopNavMenu({ navItems }: NavMenuProps) {
  return (
    <NavigationMenu className="hidden md:block">
      <NavigationMenuList>
        {navItems.map((item) => (
          <NavigationNavItem key={item.name} item={item} />
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
}